import { useCallback } from "react";
import clsx from "clsx";
import { Identical, localizationIdentical } from "@/domains/createCharacter/constants/genetics";

type Props = {
  variants: [Identical, Identical];
  selectedVariant: Identical;
  onChange: (value: Identical) => void;
};

export default function CreateCharacterIdentical({ variants, selectedVariant, onChange }: Props) {
  const avatar = useCallback((variant: Identical) => {
    switch (variant) {
      case Identical.Father:
        return "father";
      case Identical.Mother:
        return "mother";
      case Identical.GrandFather:
        return "father";
      case Identical.GrandMother:
        return "mother";
      default:
        return "";
    }
  }, []);

  return (
    <div className="grid grid-cols-2 gap-1.5 h-[15.625rem]">
      {variants.map((item, index) => (
        <button
          key={item}
          type="button"
          className={clsx(
            "btn text-15 font-bold w-full rounded-lg flex flex-col h-full relative",
            item === selectedVariant
              ? "variant-solid-gradient pointer-events-none mz-noninteractive"
              : "variant-soft variant-gray",
          )}
          onClick={() => onChange(item)}
        >
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(/img/customization/${avatar(item)}.png)`,
              backgroundRepeat: "no-repeat",
              backgroundPositionX: "center",
              backgroundPositionY: "bottom",
              backgroundSize: "100%",
              transform: index % 2 === 0 ? "rotateY(180deg)" : undefined,
            }}
          />
          <span
            className={clsx("absolute top-5 capitalize", index % 2 === 0 ? "left-5" : "right-5")}
          >
            {localizationIdentical[item]}
          </span>
        </button>
      ))}
    </div>
  );
}
